<script setup lang="ts">
import { userService } from "@/shared/user/user.service";
import { useActions, useGetters } from "@/store/vuex-composition-mappers";
import { userThemesService } from "@/shared/themes/user-themes.service";
import { computed, onMounted } from "vue";
import { CardSquare, CardSquareColors, CardsSquare } from "@easy/ui/cards";
import { AddIcon } from "@easy/ui/icons";
import type { Theme } from "@/shared/themes/Theme.interface";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const { brandingLink } = useGetters(["brandingLink"]);
// @ts-expect-error
const { colorThemes } = useGetters("theme", ["colorThemes"]);
// @ts-expect-error
const { getUserThemes } = useActions("theme", ["getUserThemes"]);
const model = defineModel<Theme>();
const emit = defineEmits(["updateColors"]);

const currentTheme = computed<Theme>(() =>
    colorThemes.value.find((preset: Theme) => preset.id === model.value?.id)
);
const colorThemesWithoutUser = computed<Theme[]>(() =>
    colorThemes.value.filter((preset: Theme) => preset.id !== userThemesService.THEME_USER_ID)
);

onMounted(() => {
    getUserThemes();
});

function setTheme(theme: Theme) {
    model.value = theme;
    emit("updateColors", { theme });
}

async function goToBranding() {
    // @ts-expect-error
    const { magicUrl } = await userService.forgeMagicLink(brandingLink.value);
    window.open(magicUrl, "_blank");
}
</script>

<template>
    <CardsSquare>
        <CardSquareColors
            @click="setTheme(preset)"
            v-for="preset in colorThemesWithoutUser"
            :key="preset.id"
            :title="preset.name"
            :colors="[
                preset.colors.brand,
                preset.colors.background,
                preset.colors.cardBackground,
                preset.colors.text,
            ]"
            :is-selected="preset.id === currentTheme?.id"
        />
        <CardSquare :title="$t('shared.creator.create_new')" @click="goToBranding">
            <AddIcon class="h-6 w-6 ct-fg-1" />
        </CardSquare>
    </CardsSquare>
</template>
